import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import Footer from "./footer";

const Expensemanagement = () => {
  const [pageData, setPageData] = useState(null);

  const fetchSeoData = async () => {
    try {
      const response = await fetch("/seo.json");
      const data = await response.json();

      if (data.status === "0" && Array.isArray(data.data)) {
        const pages = data.data[0]?.pages || [];

        console.log("Pages Data:", pages);

        const faqPageData = pages.find((page) => page.page_id === "12");

        if (faqPageData) {
          console.log("FAQ Page Data:", faqPageData.basic_settings.tittle);
          setPageData(faqPageData);
        } else {
          console.log("FAQ page not found");
        }
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    }
  };

  useEffect(() => {
    fetchSeoData();
    window.scrollTo({ top: 0, behavior: "smooth" });
    const script = document.createElement("script");
    script.src = "./on_seo.js";
    script.type = "module";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <h1 className="text-center mt-4 px-5 mx-5">
        Best Expense Management Software in India 2025 – Organize & Track
        Expense Efficiently
      </h1>
      <div className="d-flex justify-content-center">
        <img
          src="https://billpunch.com/billpunchImages/HR%20Crisis.png"
          style={{ height: "50vh" }}
        />
      </div>
      <div className="row mt-md-2">
        <div className="col-md-1"></div>
        <div className="col-md-8">
          <h2>Simplify & Automate Your Corporate Expense Management</h2>
          <p>
            Business expense management really helps in keeping a business
            financially viable, legally compliant, and its employees happy.
            BillPunch HRMS Expense Management system is an effective automated
            tracking mechanism for effortless, visible, and simple reimbursement
            of expenses incurred by employees. Whether your company deals with:
          </p>
          <ul>
            <li>Travel expenses</li>
            <li>Office purchases</li>
            <li>Project-related costs</li>
          </ul>
          <p>
            Cloud-based solutions from this service provider bring automation
            for processing expenses, better control over spending, and
            integration for seamless payroll integration.
          </p>

          <h5>Key Features of BillPunch's Expense Management Software</h5>

          <h5>Easy-to-Use Interface with Mobile Access</h5>
          <ul>
            <li>
              Fast and easy expense submission and approval tracking through an
              intuitive dashboard.
            </li>
            <li>
              Expense Report App from Anywhere: Receipts Submitted while
              On-the-Go.
            </li>
          </ul>

          <h5>Quick and Easy Submission and Categorization of Expenses</h5>
          <ul>
            <li>
              Flexibly upload receipts in more than one format (PDF, images,
              scanned bills).
            </li>
            <li>
              Categorize expenses (travel, food, office supplies, fuel, lodging)
              for better tracking.
            </li>
          </ul>

          <h5>Automated Approval Workflows & Alerts in Real Time</h5>
          <ul>
            <li>
              A multi-level approval system designed according to amount,
              department, or category.
            </li>
            <li>
              Instant alerts for managers to approve/reject claims without
              delays.
            </li>
          </ul>

          <h5>Policy Compliance & Fraud Prevention</h5>
          <ul>
            <li>
              Automated policy checks enforcing corporate rules on expenses.
            </li>
            <li>
              Violation alerts while claims are being claimed
              beyond-the-policies.
            </li>
          </ul>

          <h5>Advance Expense Tracking, Reports, & Analytics</h5>
          <ul>
            <li>
              Spending trends, expenses department-wise, and top categories in
              spending are all defined.
            </li>
            <li>
              AI analytics producing insights to identify cost-saving
              opportunities.
            </li>
          </ul>

          <h5>Hassle-Free Integration with Payroll, ERP & Banking Systems</h5>
          <ul>
            <li>
              Automatically sync data into ERP for financial reconciliation.
            </li>
            <li>
              Integrate with direct banking for faster and more secure
              reimbursements.
            </li>
          </ul>

          <h5>Data Security, Compliance & Audit Readiness</h5>
          <ul>
            <li>Sensitive financial data encrypted.</li>
            <li>Audit trails attached to all expense-related activities.</li>
          </ul>

          <h5>Dedicated Employee Support & Training Resources</h5>
          <ul>
            <li>
              Integrated helpdesk for queries relating to expense claims and
              approvals.
            </li>
            <li>
              Easy to follow, step-by-step tutorials to ease navigation by
              employees in the system.
            </li>
          </ul>

          <h5>
            Why Choose BillPunch – Best Expense Management Software in India?
          </h5>

          <h5>Boosts Efficiency</h5>
          <ul>
            <li>
              It applies automation on expense tracking, approvals, and member
              reimbursements; saves time and effort.
            </li>
          </ul>

          <h5>Fosters Transparency</h5>
          <ul>
            <li>
              Ensure 100% visibility into expenses and reimbursements to earn
              trust.
            </li>
          </ul>

          <h5>Enhances Cost Control & Compliance</h5>
          <ul>
            <li>Real-time expense monitoring prevents overspending.</li>
            <li>Strict policy enforcement ensures financial discipline.</li>
          </ul>

          <h5>Increased Cost Control & Compliance</h5>
          <ul>
            <li>Immediate expense aversion limits wasting cash.</li>
            <li>
              Strict policy enforcement makes financial discipline the norm.
            </li>
          </ul>

          <h5>
            Quick reimbursement leads to a better employee experience. Transform
            Your Business with BillPunch's Expense Management System.
          </h5>
          <p>
            BillPunch’s HRMS, Japan, Expense Management Module is very effective
            as it helps firms that are in India manage finance operations,
            automate approvals, and maintain compliance. Automated receipt
            scanning and a bank-linked reimbursement all narrow down efforts in
            cutting costs and improving efficiency.
          </p>
        </div>

        <div className="col-md-1"></div>
      </div>

      <Footer />
    </>
  );
};

export default Expensemanagement;
